export default __webpack_public_path__ + "58a212c2183de857ba8caf85a2d82bea.svg";